import { Language, LanguageType } from '@nx-smartmonkey/shared/domain';
import { Translation } from '../../domain/translation/Translation';
import { TranslationDomain } from '../../domain/translation/TranslationDomain';
import { TranslationDTO } from '../../domain/translation/TranslationDTO';

export class TranslationMapper {
  static toDomain(translation: TranslationDTO): Translation {
    const languageDomain = Language.create(translation.language as LanguageType);
    return Translation.create(
      {
        language: languageDomain,
        domain: translation.domain as TranslationDomain,
        value: translation.value,
        original_value: translation.original_value,
        key: translation.key,
        created_at: translation.created_at,
        created_by: translation.created_by,
        updated_at: translation.updated_at,
        updated_by: translation.updated_by,
        auto_translate: translation.auto_translate,
        is_empty: translation.is_empty,
      },
      translation.id
    );
  }
}
